export const enLocale = {
  welcome: {
    title: "Welcome to Vomi",
    subtitle: "Please enter your display name to continue",
    displayNameLabel: "Display Name",
    displayNamePlaceholder: "Enter your name or alias",
    continueButton: "Continue",
    logout: "Logout",
    footer: "Vomi Business Portal • Secure Access",
    validation: {
      nameRequired: "Please enter your display name",
    },
    success: {
      welcomeMessage: "Welcome {name}! App features will be added here.",
    },
  },
  nativeLogin: {
    title: "Login",
    emailLabel: "Email",
    passwordLabel: "Password",
    submit: "Log in",
    invalidCredentials: "Invalid email or password.",
    otpRequired: "This account needs an extra verification step that isn't supported here. Please log in via the browser instead.",
    genericError: "Login failed. Please try again.",
    browserFallback: "Log in via browser",
  },
  toast: {
    error: "Error",
    success: "Success",
    defaultError: "An error occurred",
    tracingIdPrefix: "Error ID",
    copyErrorId: "Copy error ID",
    errorIdCopied: "Error ID copied.",
    errorIdCopyFailed: "Copying failed. Please select and copy the ID manually.",
  },
  common: {
    loading: "Loading...",
    error: "An error occurred",
    notAvailable: "Not available",
    retry: "Try again",
    back: "Back",
    cancel: "Cancel",
    save: "Save",
    close: "Close",
    upload: "Upload",
    remove: "Remove",
    select: "Select",
    edit: "Edit",
    yes: "Yes",
    no: "No",
    documentSaved: "Document saved",
    scrollLeft: "Scroll left",
    scrollRight: "Scroll right",
    documentOpenError: "Document saved, but could not be opened.",
  },
  nav: {
    home: "Home",
    add: "Employees",
    hours: "Hours",
    payroll: "Payroll",
    reports: "Reports",
  },
  support: {
    buttonLabel: "Help and feedback",
    title: "Share your opinion",
    requiredHint: "Required fields are marked with an asterisk.",
    typeLabel: "Select the type of feedback",
    typePlaceholder: "Select",
    textLabel: "Your message",
    textPlaceholder: "Write your message here",
    submit: "Send",
    types: {
      QUESTION: "Ask a question",
      COMMENT: "Leave a comment",
      BUG: "Report a bug",
      IMPROVEMENT: "Suggest an improvement",
    },
    validation: {
      typeRequired: "Select the type of feedback.",
      textRequired: "Enter the message text.",
    },
    success: "Your message was sent successfully.",
    error: "The message cannot be sent right now. Please try again.",
  },
  profile: {
    title: "Profile",
    logout: "Logout",
    accountSettings: "ACCOUNT SETTINGS",
    clientSettings: "CLIENT SETTINGS",
    email: "Email",
    phone: "Phone",
    company: "Company",
    preferences: "PREFERENCES",
    language: "Language",
    signature: "Signature",
    addSignature: "Add signature",
    notifications: "Notifications",
    manageNotifications: "Manage your notification preferences",
    assignedEmployees: "ASSIGNED STAFF",
    assignedEmployeeFinanceAndVat: "Finance and VAT",
    assignedEmployeeSalaryCalculation: "Payroll",
    assignedEmployeeFinalReport: "Annual reports",
    assignedEmployeeNotAssigned: "No staff member assigned yet.",
    legal: "Legal documents",
    legalOpenExternal: "Open in browser",
    legalDocs: {
      uvjeti: "Terms of Use",
      privatnost: "Privacy Policy",
      kolacici: "Cookie Policy",
      podizvrsitelji: "List of sub-processors",
      prihvatljivo: "Acceptable Use Policy",
      sigurnost: "Security and incident reporting",
      impressum: "Provider information",
    },
    security: "Security",
    securityDescription: "Password, two-factor authentication",
    annualHolidays: "Annual Holidays",
    settingsAnnualHolidays: "Settings for annual holidays",
    profilePicture: "Profile Picture",
    supportedFormats: "PNG, JPG or GIF (max. 5MB)",
    currentProfilePicture: "Current Profile Picture",
    uploadedOn: "Uploaded on",
    uploadNew: "Upload New",
    editEmail: "Edit Email",
    emailAddress: "Email Address",
    emailPlaceholder: "Enter your email",
    editPhone: "Edit Phone Number",
    phoneNumber: "Phone Number",
    phonePlaceholder: "Enter your phone number",
    editCompany: "Edit Company",
    companyName: "Company Name",
    companyPlaceholder: "Enter your company name",
    selectLanguage: "Select Language",
    preferredLanguage: "Preferred Language",
    languagePlaceholder: "Select a language",
    electronicSignature: "Electronic Signature",
    drawSignature: "Draw your signature in the box below",
    clearSignature: "Clear",
    useTypedSignature: "Use Typed Signature",
    typeSignature: "Type your signature",
    typeSignaturePlaceholder: "Type your signature",
    saveSignature: "Save Signature",
    selectHolidayDates: "Select your annual holiday dates",
    selectedDates: "Selected Dates",
    noDatesSelected: "No dates selected",
    moreDates: "more dates",
    saveHolidays: "Save Holidays",
    holidaysDescription: "Overview of configured public holidays.",
    holidayCountry: "Holiday country",
    holidayCountryCroatia: "Croatia",
    holidayCountryGermany: "Germany",
    notificationSettings: "Notification Settings",
    notificationMessage: "Notification management will be available soon.",
    securitySettings: "Security Settings",
    securityMessage: "Security settings management will be available soon.",
    signatureSaved: "Saved",
    currentSignature: "Current signature",
    updateSignature: "Update signature",
    fileTooLarge: "File size exceeds 5MB limit",
    invalidFileType: "Please upload a valid image (JPG, PNG, GIF, WebP)",
    uploadFailed: "Failed to read the file. Please try again.",
    contactsTitle: "Contacts",
    noContacts: "No contacts",
    primaryContact: "Primary",
    accountDetails: "Account Details",
    firstName: "First Name",
    lastName: "Last Name",
    companyDetails: "Company Details",
    noCompanyData: "No company data",
    businessType: "Business Type",
    messages: {
      imageSaved: "Profile picture saved successfully",
      imageDeleted: "Profile picture deleted",
      signatureSaved: "Signature saved successfully",
    },
  },
  termsGate: {
    title: "Terms of Use",
    text: "To keep using the application you must accept the current Terms of Use (version {version}).",
    open: "Open the Terms of Use",
    agree: "I have read and accept the Terms of Use.",
    continue: "Continue",
  },
  languages: {
    english: "English",
    croatian: "Croatian",
    german: "German",
  },
  months: {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
  },
  days: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
  },
  validation: {
    required: "This field is required",
    invalidEmail: "Please enter a valid email address",
    invalidPhone: "Please enter a valid phone number",
    minLength: "Must be at least {length} characters",
    maxLength: "Must be less than {length} characters",
  },
  clientEmployees: {
    title: "Current Employees",
    searchPlaceholder: "Search employees...",
    addEmployee: "Add Employee",
    editEmployee: "Edit Employee",
    confirmCancelMessage: "Are you sure you want to cancel? All entered data will be lost.",
    noEmployees: "No employees found",
    firstName: "First Name",
    lastName: "Last Name",
    oib: "OIB",
    sortPlaceholder: "Sort by…",
    sortDirectionLabel: "Toggle sort direction",
    status: "Status",
    statusActive: "Active",
    statusInactive: "Inactive",
    statusPending: "Pending",
    note: "Note",
    noteReminder: "Reminder",
    pendingMessage: "Registration is being processed by VOMI. The contract will be available once completed.",
    street: "Street",
    houseNumber: "House Number",
    city: "City",
    postalCode: "Postal Code",
    country: "Country",
    addressAddition: "Address Addition",
    address: "Address",
    deactivate: "Deactivate",
    terminate: "Deregister",
    terminateEmployee: "Deregister employee",
    archive: "Archive",
    showInactive: "Show inactive",
    filterActive: "Active",
    filterPending: "In preparation",
    filterInactive: "Deregistered",
    noActiveEmployees: "No active employees",
    noPendingEmployees: "No employees in preparation",
    noInactiveEmployees: "No deregistered employees",
    noSearchResults: "No search results",
    deactivateConfirmTitle: "Deactivate Employee",
    deactivateConfirmMessage:
      "Are you sure you want to deactivate this employee?",
    archiveConfirmTitle: "Archive Employee",
    archiveConfirmMessage:
      "Are you sure you want to archive this employee?",
    formValidation: {
      requiredHint: "Required fields are marked with an asterisk (*).",
      fixErrors: "Unable to continue — please correct the fields marked in red.",
      firstNameRequired: "Enter the first name.",
      lastNameRequired: "Enter the last name.",
      streetRequired: "Enter the street.",
      houseNumberRequired: "Enter the house number.",
      cityRequired: "Enter the city.",
      postalCodeRequired: "Enter the postal code.",
      countryRequired: "Enter the country.",
      oibRequired: "Enter the OIB.",
      oibInvalid: "Enter the OIB in the correct format (11 digits).",
    },
    onboarding: {
      title: "Employee Onboarding",
      subtitle: "Manage new employee setup and documentation",
      requiredDocuments: "Required Documents",
      documentsLabel: "Documents",
      formTitle: "Employee Information",
      documents: {
        personalId: "Personal ID and basic information",
        personalIdDesc: "Personal documents and basic information",
        taxCard: "Tax card",
        taxCardDesc: "Tax documents and cards",
        iban: "IBAN of regular and protected account",
        ibanDesc: "Bank accounts for salary payment",
        workRecord: "Electronic work record",
        workRecordDesc: "Digital record of work experience",
        workPermit: "Work permit",
        workPermitDesc: "Scan or photo of the valid work permit",
        upload: "Upload",
        uploadHint: "PDF, JPG or PNG, max 5MB",
        uploaded: "Uploaded",
        required: "Required",
        optional: "Optional",
        deadlineDays: "Deadline: 5 days",
        fileTooLarge: "File too large (max 5MB)",
        uploadSuccess: "Documents sent successfully",
        requiredDocsMessage: "Upload Personal ID",
        pendingDocs: "Missing documents",
        sendDocuments: "Send documents",
        deadlineRemaining: "{documents} — {days} days remaining to upload",
        deadlineRemainingOne: "{documents} — {days} day remaining to upload",
        deadlineExpired: "{documents} — upload deadline has passed!",
        ibanChoose: "How would you like to add IBAN?",
        ibanUploadFile: "Upload document",
        ibanEnterManually: "Enter IBAN manually",
        ibanPlaceholder: "HR1234567890123456789",
        ibanManuallyEntered: "IBAN manually entered",
        ibanValidation: "Enter a valid IBAN (HR + 19 digits)",
      },
      actions: {
        chooseAction: "Choose an action",
        change: "Change",
        deactivate: "Deactivate",
        terminate: "Deregister",
        archive: "Archive",
      },
    },
    actions: {
      header: "Actions",
      edit: "Edit",
      deactivate: "Deactivate",
      archive: "Archive",
    },
    contract: {
      title: "Employment Contract",
      contractStartDate: "Contract start date",
      jobTitle: "Job title",
      jobTitlePlaceholder: "e.g. Accountant",
      contractType: "Contract type",
      fullTime: "Full-time",
      partTime: "Part-time",
      workingHours: "Weekly hours",
      workingHoursPlaceholder: "e.g. 20 or 20:00",
      scheduleType: "Work schedule",
      scheduleFixed: "Fixed",
      scheduleAgreement: "By agreement",
      scheduleShift: "Shift work",
      shift: {
        typeLabel: "Type of shift work",
        daily: "Daily shifts",
        dailyHint: "Working time is set per day",
        weekly: "Weekly shifts",
        weeklyHint: "Shifts rotate automatically every week",
        dailySectionTitle: "Working time per day",
        days: {
          MONDAY: "Mon",
          TUESDAY: "Tue",
          WEDNESDAY: "Wed",
          THURSDAY: "Thu",
          FRIDAY: "Fri",
          SATURDAY: "Sat",
          SUNDAY: "Sun",
        },
        start: "Start",
        end: "End",
        dayOff: "day off",
        workingDay: "Working day",
        freeDay: "Day off",
        copyMonday: "Copy Monday to working days",
        fundOver: "{diff} over the contracted hours ({fund})",
        fundUnder: "{diff} under the contracted hours ({fund})",
        weeklyTotal: "Weekly total",
        rotationSectionTitle: "Shifts in rotation",
        shiftName: "Shift name",
        unnamedShift: "(unnamed)",
        newShiftName: "Shift {n}",
        addShift: "Add shift",
        removeShift: "Remove shift",
        workingDays: "Working days per week",
        workingDaysHint: "Each shift has its own working days — e.g. 5 days one week, 6 the next. The 5 or 6 days button sets a default (a shorter Saturday for 6 days); then edit days and times. Every week must match the contracted hours.",
        firstWeekShift: "Shift in the first week of the contract",
        firstWeekShiftHint: "The rotation counts from the week the contract starts and continues through all shifts in order.",
        previewTitle: "Rotation preview (first 6 weeks)",
        previewWeek: "Week {n}",
        previewNeedsStartDate: "The rotation preview is shown once the contract start date is selected.",
        perShiftWeekly: "Weekly per shift",
        contractedFund: "Contracted hours",
        validation: {
          dailyNoDays: "Select at least one working day for daily shifts.",
          invalidTime: "Shift start and end must be in HH:MM format.",
          sameStartEnd: "Shift start and end must not be the same.",
          weeklyMinTwoShifts: "Weekly shifts need at least two shifts.",
          weeklyFirstShiftRequired: "Select the shift for the first week of the contract.",
          weeklyShiftNameRequired: "Shift name is required.",
          weeklyNoDays: "Shift \"{name}\" must have at least one working day.",
          weeklyUnequalShifts: "All shifts in the rotation must have the same weekly duration.",
          dailyFundMismatch: "The weekly total must match the contracted {expected} (you entered {total}).",
          weeklyFundMismatch: "Weekly hours per shift must match the contracted {expected} (you entered {total}).",
        },
      },
      weeklyScheduleType: "Weekly schedule",
      fiveDaySchedule: "Five-day (Mon-Fri)",
      sixDaySchedule: "Six-day (Mon-Sat)",
      sixDayScheduleHint: "Saturday counts as a regular working day (not overtime).",
      contractDuration: "Contract duration",
      durationIndefinite: "Indefinite",
      durationDefinite: "Fixed-term",
      reason: "Reason for fixed-term contract",
      reasonPlaceholder: "e.g. Maternity leave replacement",
      vacationDays: "Annual leave (days)",
      vacationDaysPlaceholder: "min. 20",
      proportionalVacationDays: "Proportional vacation",
      proportionalVacationDaysNote: "An employee on a fixed-term contract is entitled to a proportional share of annual leave, calculated according to the length of the employment.",
      salaryType: "Salary type",
      salaryTypeBruto: "Gross",
      salaryTypeNeto: "Net",
      monthlyGrossSalary: "Monthly gross salary (EUR)",
      salaryPlaceholder: "Gross salary amount",
      salaryNote: "Gross salary is not the final cost — health insurance contribution is calculated additionally.",
      minimumGrossSalaryNote: "The minimum gross salary amount is {amount} (value is retrieved from system settings).",
      minimumGrossSalaryPartTimeNote: "For part-time employment the minimum gross salary is proportional to the weekly hours: {percent} % of {full} = {amount}.",
      desiredNetSalary: "Desired net salary (EUR)",
      desiredNetSalaryPlaceholder: "min. {amount}",
      desiredNetSalaryPartTimeNote: "For part-time employment the minimum net amount is proportional to the weekly hours: {percent} % of {full} € = {amount} €.",
      desiredNetSalaryNote: "The final net salary amount depends on the tax rules of the employee's city/municipality of residence and may require adjustment. Vomi will prepare the employment contract with the corresponding gross amount, taking into account the entered desired net amount.",
      allowances: "Non-taxable salary supplements (optional)",
      transportCost: "Transport (EUR/mo)",
      transportCostNote: "Up to the actual monthly public transport pass amount",
      mealAllowance: "Meal allowance (EUR/mo)",
      mealAllowanceNote: "Up to {limit} EUR monthly",
      performanceBonus: "Performance bonus (EUR/mo)",
      performanceBonusNote: "Up to {limit} EUR annually",
      occasionalBonus: "Occasional bonus (EUR/mo)",
      occasionalBonusNote: "Up to {limit} EUR annually",
      mealAllowanceWarn: "Warning: recommended maximum for meal allowance is {limit} EUR monthly",
      performanceBonusWarn: "Warning: recommended maximum for performance bonus is {limit} EUR annually",
      occasionalBonusWarn: "Warning: recommended maximum for occasional bonus is {limit} EUR annually",
      workingHoursFormat: "Weekly part-time hours, in whole hours or HH:MM format (00:01–39:59)",
      workingHoursInvalid: "Enter weekly hours in HH:MM format (00:01–39:59)",
      contractStartDateRequired: "Enter the employment start date.",
      contractStartDateInvalid: "Contract start date must be today or later (tomorrow or later after 14:00), and no more than 30 days ahead.",
      contractStartDateHint: "Same-day registration is only possible until 14:00 — after that the earliest available date is tomorrow.",
      jobTitleRequired: "Enter the job title.",
      workingHoursRequired: "Enter the weekly hours for part-time employment.",
      reasonRequired: "Enter the reason for the fixed-term contract.",
      vacationDaysRequired: "Enter the number of annual leave days.",
      vacationDaysMin: "Minimum annual leave is {min} days.",
      salaryRequired: "Enter the gross salary amount.",
      salaryPositive: "Amount must be greater than 0.",
      salaryBelowMinimum: "Gross salary for full-time employment must not be less than {amount}.",
      salaryBelowPartTimeMinimum: "Gross salary for the entered part-time hours must not be less than {amount}.",
      desiredNetSalaryRequired: "Desired net salary amount is required.",
      desiredNetSalaryBelowMinimum: "The minimum net salary amount is {amount} €.",
      amountNotNegative: "Amount must not be negative.",
      notDefined: "Contract not defined",
      editDisabled: "Contract editing will be available in a future update (annex)",
      editTitle: "Edit contract",
      changesRequireAmendment: "This change requires a contract amendment (annex)",
      changesRequireNewContract: "This change requires a new employment contract",
      changeRejected: "This change is not allowed. Contract duration cannot change from Definite to Indefinite.",
      contractTypeLockedHint: "Contract type is locked to part-time because of additional work",
      updateSuccessEdit: "Contract updated",
      updateSuccessAnnex: "Contract annex created. PDF is being generated.",
      updateSuccessNewContract: "New employment contract created. PDF is being generated.",
      updateError: "Failed to update the contract",
      annexForSigningTitle: "Annex ready for signing",
      newContractForSigningTitle: "New contract ready for signing",
      newContractDownload: "Download new contract",
      newContractConfirmAction: "Sign new contract",
      newContractConfirmedBadge: "New contract signed",
      annexForSigningHint: "Give the document to the employee for signing and deliver it to accounting or archive it locally.",
      annexConfirmAction: "Sign annex",
      annexConfirmedBadge: "Annex signed",
      annexNotReadyYet: "The annex is not ready yet. You will be notified once VOMI prepares the document.",
      annexDownload: "Download annex",
      annexConfirmSuccess: "Annex confirmed successfully.",
      annexConfirmError: "Failed to confirm the annex.",
      history: "Contract history",
      noHistory: "No previous contract versions",
      historyVersionNew: "Original contract",
      historyVersionEdit: "Contract amendment",
      annexAppliedBadge: "Annex applied",
      newContractAppliedBadge: "New contract",
      historyChangeDate: "Change date",
      historyDetailsTitle: "Contract details",
      historyViewDetails: "View details",
      downloadContract: "Download contract",
      isForeigner: "Foreigner",
      firstEmploymentReliefQuestion: "Use of contribution relief (first employment)",
      firstEmploymentReliefHint: "Condition: indefinite-duration contract.",
      citizenshipQuestion: "Citizenship",
      citizenshipEu: "EU / EEA / Switzerland",
      citizenshipThirdCountry: "Third country",
      workPermitQuestion: "Does the person have a valid work permit obtained by your company?",
      workPermitHasPermit: "The person has a valid work permit",
      workPermitNoPermit: "The person does not have a work permit",
      workPermitRequired: "Attaching the work permit is required.",
      workPermitBlockedTitle: "Registration not possible",
      workPermitBlockedMessage: "The employee cannot be registered without a valid work permit. Contact Vomi d.o.o. to check the conditions the employer and employee must meet. Vomi d.o.o. can offer you a work permit application service.",
      workPermitUploadAfterApproval: "The work permit will be requested once a Master approves this request.",
      isAdditionalWork: "Additional work",
      additionalWorkMaxHours: "Additional work may not exceed 8 hours per week.",
      worksSaturday: "Works Saturdays",
      worksSaturdayRequiresSixDay: "Saturday work is only possible with a six-day weekly schedule.",
      worksSaturdayRequiresFullTimeFixed: "Saturday work is only possible with a full-time fixed schedule.",
      worksSaturdayLegacy: "Carried over from an earlier contract. It stays as it is, but it can no longer be switched back on.",
      worksSaturdayAdditionalWork: "For additional work, Saturday work can be switched on as needed. Saturday counts towards the weekly limit of 8 hours, and the schedule is then \"By agreement\".",
      agreementScheduleSaturdayHint: "With a schedule by agreement, working days (including Saturdays) are entered manually in the work time records.",
      passportNumber: "Passport number",
      passportNumberPlaceholder: "e.g. AB1234567",
      passportNumberRequired: "Enter the passport number (required for foreign employees).",
      probationPeriod: "Probation period (months)",
      probationPeriodRange: "Probation period must be between 1 and 6 months. If the employment lasts less than one month, leave this field empty.",
      probationPeriodExceedsContract: "Probation period must not be longer than the fixed-term contract duration.",
      probationPeriodShortContractHint: "If the employment lasts less than one month, leave this field empty.",
      probationPeriodShortContract: "The employment lasts less than one month — leave this field empty.",
      workLocation: "Work location",
      workLocationPlaceholder: "e.g. Zagreb",
      contractEndDate: "Contract end date",
      contractEndDateRequired: "Enter the end date of the fixed-term contract.",
      workStartTime: "Work start",
      workEndTime: "Work end",
      workStartTimePlaceholder: "08:00",
      workEndTimePlaceholder: "16:00",
      workEndTimeAutoCalculated: "Calculated automatically from the work start and weekly hours.",
      workEndTimeAutoCalculatedMismatch: "Work end must be {time} (work start + weekly hours / 5).",
      workTimeFormat: "HH:MM format (00:00–23:59)",
      workTimeInvalid: "Enter the time in HH:MM format (00:00–23:59).",
      workEndAfterStart: "Work end must be after work start.",
      workStartTimeRequired: "This field is required when a fixed working time is selected.",
      workEndTimeRequired: "This field is required when a fixed working time is selected.",
      fixedScheduleHint: "With a fixed working time, all related fields marked with an asterisk must be filled in (work start and end time).",
      workTimeFullTimeSpanInvalid: "For full-time employment, the work time span must be {hours}h.",
      partTimeSixDayFixedDisabled: "A fixed schedule isn't possible with part-time work on Saturdays. Use 'By agreement' and enter hours manually per day.",
      workingHoursNotDivisibleBy5: "The weekly hours aren't evenly divisible by 5 (working days). Use 'By agreement' instead of 'Fixed' and enter hours manually per day.",
      downloadDisabled: "Contract document generation will be available in a future update",
      documentSection: "Contract document",
      notReadyYet: "The document is not ready yet. You will be notified once VOMI prepares the contract.",
      confirmDocument: "Sign document",
      signatureRequired: "Set up a digital signature in your profile to confirm the document.",
      confirmHint: "Hand the document to the employee for signing and deliver it to accounting or archive it yourself.",
      confirmedBadge: "Signed",
      downloadError: "Error downloading the document.",
      confirmSuccess: "The document has been confirmed.",
      confirmError: "Error confirming the document.",
      alreadyConfirmed: "The document has already been confirmed.",
    },
    detail: {
      personalData: "Personal data",
      tabs: {
        overview: "Overview",
        contract: "Contract",
        absences: "Absences",
        hours: "Work hours",
        nonTaxable: "Non-taxable payments",
      },
      absencesPlaceholder: "Absences — coming soon",
      absencesSubtext: "Sick leave and annual leave",
      hoursPlaceholder: "Work hours — coming soon",
      hoursSubtext: "Working time records",
      salarySection: "Salary & allowances",
      workTime: {
        title: "Work hours",
        periodLabel: "Period",
        empty: "No data for the selected period",
        pendingMessage: "The employee has not yet been confirmed by VOMI. Work hours will be available once the registration is confirmed.",
        noDays: "There are no daily entries for the selected month — the employee was out of the work-time record (e.g. on a long-term absence).",
        lockedMessage: "Work hours and the payroll calculation date cannot be edited because the payroll calculation is in progress or completed. Please contact Vomi d.o.o. for changes.",
        loading: "Loading work hours...",
        error: "Failed to load work hours",
        retry: "Try again",
        plannedShiftHint: "Contracted working hours — day not entered manually",
        shiftWeeks: {
          title: "Shifts by week",
          hint: "Weeks follow the rotation from the contract. For the current and upcoming weeks you can pick another shift — it applies to that week only.",
          changed: "Changed manually",
          resetToRotation: "Back to rotation",
          saved: "Shift for the week saved",
        },
        dayType: {
          REGULAR: "Regular",
          WEEKEND: "Weekend",
          HOLIDAY: "Holiday",
          VACATION: "Annual leave",
          SICK_LEAVE: "Sick leave",
        },
        columns: {
          date: "Date",
          type: "Type",
          start: "Start",
          end: "End",
          regular: "Regular",
          overtime: "Overtime",
          night: "Night",
        },
        totals: {
          regular: "Total regular",
          overtime: "Total overtime",
          night: "Total night",
        },
        form: {
          startTime: "Start",
          endTime: "End",
          overtimeMinutes: "Overtime",
          overtimeUnit: "min",
          egPrefix: "e.g.",
          invalidTime: "Enter a valid time (00:00–23:59)",
          invalidOvertime: "Overtime must be a non-negative number",
          exceedsDailyFond: "The entered working time exceeds the employee's defined daily fond of {max} hours.",
          exceedsWeeklyRegular: "Only {remaining} h of regular work is left this week (at most {max} h per week). Enter the rest as overtime.",
          weeklyRegularFull: "The weekly fond of {max} h of regular work is full — the whole shift is recorded as overtime.",
          saturdayOvertime: "The whole Saturday is recorded as overtime; enter extra hours by extending the working time.",
          exceedsYearlyOvertime: "Yearly overtime would amount to {total} h, while at most {max} h is allowed.",
          yearlyOvertimeWarning: "Yearly overtime will amount to {total} h. The statutory yearly limit is {warning} h unless a collective agreement defines more (at most {max} h).",
          editTitle: "Work-time entry",
        },
        actions: {
          edit: "Edit",
          save: "Save",
          cancel: "Cancel",
          delete: "Delete entry",
          notWorked: "Didn't work",
        },
        source: {
          MANUAL: "Manual",
          PENDING: "Awaiting entry",
        },
        toast: {
          saved: "Entry saved successfully",
          deleted: "Entry deleted successfully",
        },
      },
    },
    nonTaxable: {
      title: "Non-taxable payments",
      type: "Payment type",
      oneOffTitle: "One-off payment",
      paymentsTitle: "Payments",
      noPayments: "No payments recorded for this type.",
      amount: "Amount (EUR)",
      payoutOption: "Payout option",
      uzPlacu: "With next salary",
      naDatum: "On date",
      payoutDate: "Payout date",
      submit: "Submit",
      confirm: "Confirm",
      downloadDecision: "Download decision",
      recurringAmount: "Fixed monthly amount (EUR)",
      recurringNote: "Paid out every month until changed or removed.",
      recurringValidFrom: "Valid from",
      recurringRemoval: "Removal of the fixed amount",
      recurringPending: "Awaiting approval: {amount}",
      recurringPendingRemoval: "Removal awaiting approval",
      recurringAction: {
        UPSERT: "change",
        DELETE: "removal",
      },
      remainingYear: "Remaining this year: {remaining} of {limit}",
      remainingMonth: "Remaining this month: {remaining} of {limit}",
      usedThisYear: "Paid out this year: {used} (no legal cap)",
      usedThisMonth: "Paid out this month: {used} (up to the actual ticket price)",
      previousEmployerMonth:
        "Of that, {amount} was already received this month from a previous employer.",
      previousEmployerYear:
        "Of that, {amount} was already received this year from a previous employer.",
      emailNotice: "An email will be sent to VOMI once the client confirms the payment.",
      otherType: "Payment type name",
      otherTypePlaceholder: "e.g. Jubilee award",
      types: {
        PRIJEVOZ: "Transport",
        TOPLI_OBROK: "Meal allowance",
        NAGRADA_ZA_RADNE_REZULTATE: "Award for work results",
        PRIGODNA_NAGRADA: "Occasional award",
        OSTALO: "Other",
      },
      statuses: {
        PENDING_APPROVAL: "Waiting for approval",
        DRAFT: "Waiting for signature",
        CONFIRMED: "Confirmed",
      },
      validation: {
        recurringRequired: "Enter the monthly amount.",
        amountPositive: "Amount must be greater than zero.",
        amountOverLimit: "Amount exceeds the remaining limit.",
        otherTypeRequired: "Payment type name is required.",
        payoutDateRequired: "Payout date is required.",
      },
      toast: {
        created: "Payment recorded",
        confirmed: "Payment confirmed",
        recurringSaved: "Fixed monthly amount saved",
        recurringRemoved: "Fixed monthly amount removed",
        recurringPending: "Request sent for approval",
      },
    },
    absences: {
      title: "Absences",
      subtitle: "Annual leave, sick leave and long-term absence",
      loading: "Loading...",
      toast: {
        created: "Request created",
        confirmed: "Absence confirmed",
        updated: "Absence updated",
        cancelled: "Absence cancelled",
        deleted: "Request deleted",
        changeRequested: "Request sent to the Master for approval",
      },
      header: {
        vacationRemaining: "Remaining annual leave days",
        daysShort: "days",
        of: "of",
      },
      carryOver: {
        summary: "incl. {days} {dayWord} carried over from {year}, use by {date}",
        detail: "Carried over from {year}: {days} {dayWord} — must be used by {date} or they lapse.",
        consumed: "All {days} {dayWord} carried over from {year} have been used.",
        expired: "{days} {dayWord} carried over from {year} were not used by {date} and can no longer be taken.",
        overdue: "The {date} deadline has passed and {days} {dayWord} carried over from {year} are still unused — please take them as soon as possible.",
      },
      tabs: {
        vacation: "Annual leave",
        sickLeave: "Sick leave",
        longTermAbsence: "Long-term absence",
        other: "Other",
      },
      type: {
        VACATION: "Annual leave",
        SICK_LEAVE: "Sick leave",
        LONG_TERM_ABSENCE: "Long-term absence",
        OTHER: "Other",
      },
      changeAction: {
        EDIT: "Edit",
        EXTEND: "Extension",
        CANCEL: "Cancellation",
      },
      status: {
        PENDING_APPROVAL: "Awaiting approval",
        DRAFT: "In preparation",
        CONFIRMED: "Confirmed",
        ACTIVE: "Active",
        CANCELLED: "Cancelled",
        // Derived on the client for a long-term absence whose end date has passed; not a stored status.
        ENDED: "Ended",
      },
      actions: {
        submit: "Send request",
        confirm: "Confirm",
        downloadPdf: "Download PDF",
        cancel: "Cancel",
        edit: "Edit",
        editEndDate: "Edit end date",
        extend: "Extend",
        save: "Save",
      },
      cancelConfirm: {
        title: "Cancel request",
        message: "Do you want to cancel the annual leave request for the period from {start} to {end}?",
        accept: "Cancel request",
        reject: "Dismiss",
      },
      vacation: {
        startDate: "Start date",
        endDate: "End date",
        legalBasis: "Legal basis (optional)",
        remaining: "Remaining: {days} {dayWord}",
        note: "Weekends and public holidays do not count towards annual leave.",
        marked: "Selected: {marked} {dayWord}, remaining: {remaining}",
        budgetWarning: "Warning: you are exceeding the available annual leave days.",
        pickRange: "Select a date range in the calendar",
        editTitle: "Edit annual leave",
      },
      sickLeave: {
        startDate: "Start date",
        endDate: "End date (optional for open sick leave)",
        type: "Sick leave type",
        otherType: "Additional explanation of the sick leave type",
        otherTypePlaceholder: "Enter an explanation",
        attachment: "Medical certificate (PDF, JPEG or PNG, max 5 MB)",
        openHint: "One click = choose between open or single-day sick leave; two clicks = range.",
        openOption: "Open sick leave",
        singleDayOption: "Sick leave lasts only one day",
        editTitle: "Edit sick leave",
        extendTitle: "Extend sick leave",
        newEndDate: "New end date (optional)",
        newAttachment: "New medical certificate",
        salaryPercentage: "Compensation percentage",
        salaryPercentageHint: "The legal minimum is 70% of the base. Enter a higher percentage if it is agreed in the employment contract, work rules, or collective agreement.",
        types: {
          UP_TO_42_DAYS: "Up to 42 days (employer-funded)",
          OVER_42_DAYS: "Over 42 days (HZZO-funded)",
          CHILD_CARE: "Child care",
          PREGNANCY_COMPLICATIONS: "Pregnancy complications",
          OCCUPATIONAL_INJURY: "Occupational illness / injury at work",
          OSTALO: "Other",
        },
      },
      other: {
        reason: "State the type of absence",
        reasonPlaceholder: "e.g. getting married, birth of a child, or death of a family member",
        hint: "One click = a one-day absence; two clicks = a range.",
        editTitle: "Edit absence",
      },
      longTermAbsence: {
        type: "Long-term absence type",
        rangeHint: "Select the period in the calendar: the first click is the start date, the second the end date.",
        hint: "While a long-term absence is in effect the employee is out of the work-time record — no daily entries are generated and no hours are due. Once the period ends the record resumes automatically.",
        masterOnly: "Only a Master can record or change a long-term absence.",
        editEndDateTitle: "Edit end date",
        editEndDateHint: "Change the end date for an earlier or later return of the employee.",
        newEndDate: "New end date",
        types: {
          PREGNANCY_COMPLICATIONS: "Pregnancy complications",
          MATERNITY_LEAVE: "Maternity leave",
          PARENTAL_LEAVE: "Parental leave",
          PATERNITY_LEAVE: "Paternity leave",
          ADOPTION_LEAVE: "Adoption leave",
          SEVERELY_DISABLED_CHILD_CARE: "Care for a child with severe developmental difficulties",
          HALF_TIME_CHILD_CARE: "Half-time work for child care",
          PAID_LEAVE: "Paid leave",
          UNPAID_LEAVE: "Unpaid leave",
          EMPLOYMENT_SUSPENSION: "Suspension of employment",
        },
      },
      list: {
        title: "All absences",
        empty: "No absences for this employee.",
        type: "Type",
        period: "Period",
        currentPeriod: "Current period",
        newPeriod: "New period",
        pendingChange: "Awaiting approval: {action}",
        amount: "Amount",
        status: "Status",
        actions: "Actions",
        open: "open",
      },
      validation: {
        required: "This field is required",
        otherTypeRequired: "This field is required when 'Other' is selected",
        dateNotPast: "Date must not be in the past",
        endAfterStart: "End date must not be before the start date",
        attachmentRequired: "Medical certificate is required",
        overlap: "The period overlaps an existing absence of this employee.",
        startBeforeEmployment: "Date must not be before the employee's start date",
        startBeforeRegistration: "The absence start date cannot be before the employee's registration date.",
      },
    },
    termination: {
      title: "Deregister employee",
      submit: "Submit deregistration",
      warning: "This action is permanent. The employee stays active until VOMI confirms the deregistration.",
      confirmTitle: "Confirm deregistration",
      confirmMessage: "Are you sure you want to submit the employee deregistration?",
      confirmAccept: "Yes, deregister",
      confirmReject: "Cancel",
      success: "Deregistration submitted — the employee stays active until VOMI confirms it.",
      pendingApproval: "Deregistration sent for Master approval.",
      type: "Termination type",
      date: "Termination date",
      noticePeriodType: "Notice period type",
      noticePeriodDays: "Notice period days",
      vacationUsed: "Has annual leave been used?",
      unusedVacationDays: "Unused annual leave days",
      vacationPreview: "On {date}, the employee will have {days} {dayWord} of annual leave remaining.",
      vacationPreviewError: "Could not calculate remaining leave for the selected date.",
      unusedVacationOption: "Unused annual leave option",
      daysToUse: "Days to use",
      daysToPayout: "Days to pay out",
      misconductOptions: "Breaches of obligations",
      misconductDescription: "Breach description",
      attachment: "Attachment (PDF, JPEG or PNG, max 5 MB)",
      types: {
        MUTUAL_AGREEMENT: "Mutual agreement",
        FIXED_TERM_EXPIRY: "Fixed-term contract expiry",
        EMPLOYEE_INITIATED: "Employee-initiated termination",
        PROBATIONARY_FAILURE: "Probationary period failure",
        WORK_PERMIT_LOSS: "Loss of work permit",
        BUSINESS_REASONS_EMPLOYER: "Business-related termination",
        EXTRAORDINARY_TERMINATION_EMPLOYEE: "Extraordinary termination by employee",
        EXTRAORDINARY_TERMINATION_EMPLOYER: "Extraordinary termination by employer",
        EMPLOYEE_MISCONDUCT_REGULAR: "Regular termination due to conduct",
        RETIREMENT: "Retirement",
        DEATH: "Death of employee",
      },
      noticePeriodTypes: {
        LEGAL: "Legal",
        AGREED: "Agreed",
      },
      vacationOptions: {
        USE_IN_NOTICE_PERIOD: "Use during notice period",
        PAYOUT: "Pay out",
        COMBINATION: "Combination",
      },
      misconductTypes: {
        UNAUTHORIZED_ABSENCE: "Unauthorized absence from work",
        REPEATED_VIOLATIONS: "Repeated breaches of obligations",
        REFUSAL_OF_WORK: "Refusal to work",
        INTOXICATION: "Working under the influence of alcohol/drugs",
        THEFT_OR_DAMAGE: "Theft or causing damage",
        BREACH_OF_CONFIDENTIALITY: "Breach of confidentiality",
        OTHER: "Other",
      },
      validation: {
        required: "This field is required",
        combinationSum: "Days to use plus days to pay out must equal the unused days.",
        attachmentRequired: "An attachment is required for this termination type",
        attachmentTooLarge: "File is too large (max 5 MB)",
        dateOutOfRange: "Termination date must be yesterday (until 14:00), today, or later, and no more than 30 days ahead.",
      },
      resolution: {
        title: "Termination decision",
        inProgress: "Deregistration in progress",
        waiting: "Deregistration submitted — VOMI is preparing the decision. The document will appear here when ready.",
        subtitle: "Review the decision and sign it digitally.",
        download: "Download",
        confirm: "Sign document",
        confirmedBadge: "Signed",
        confirmHint: "The signed document is ready to download and hand over to the employee.",
        confirmSuccess: "Document signed",
        downloadError: "Error downloading the decision",
        confirmError: "Error signing the document",
      },
    },
    messages: {
      created: "Employee successfully created",
      updated: "Employee successfully updated",
      deactivated: "Employee successfully deactivated",
      terminated: "Employee deregistration submitted successfully",
      archived: "Employee successfully archived",
      requestSent: "The request to add the employee was sent successfully. It will be completed once the Master approves it.",
      documentsMissing: "Documents not sent",
      bulkImported: "Imported via bulk import (documents not required)",
      bulkImportedDocumentsReadonly: "This employee was added via bulk import. Documents are already available in the Archive and cannot be edited here.",
    },
  },
  notifications: {
    title: "Notifications",
    taskStarted: "VOMI started processing",
    documentReady: "Document ready for signing",
    taskCompleted: "Action completed",
    employeeImportCompleted: "Employee import completed",
    employeeImportUndone: "Employee import undone",
    reportReady: "Final report ready for signing",
    contractExpiring: "Fixed-term contract expiring soon",
    employeeNoteReminder: "Employee reminder",
    approvalApproved: "Employee addition approved",
    approvalRejected: "Employee addition not approved",
    approvalRejectedReason: "Reason: {reason}",
    employeeHardDeleted: "Task and employee in preparation deleted",
    employeeHardDeletedBody: "The “{action}” task and the employee in preparation {name} have been permanently deleted.",
    employeeHardDeletedMessage: "Message from the Vomi user: {message}",
    contractExpiringNote: "Contract ends on {date}. This is the contract's natural expiry, not a deregistration request — please decide whether to extend it or deregister the employee.",
    importSummary: "VOMI imported {n} employees",
    employeeCreatedByVomi: "New employee created",
    employeeCreatedByVomiBody: "A new employee, {name}, has been created for your company. Employee details are available in the Employees module.",
    employeeCreatedByVomiWorkStart: " Work start date: {date}.",
    importFailedSuffix: "{n} failed",
    importUndoneSummary: "VOMI undid the import — {n} employees were removed",
    openToConfirm: "Open to download and confirm",
    employeeCorrected: "Employee data corrected",
    employeeDeleted: "Employee removed",
    correctedFieldsNote: "Changed fields: {fields}. Performed by: {performedBy}.",
    deletedNote: "OIB {oib}. Performed by: {performedBy}.",
    actionPrijava: "Registration",
    actionPromjena: "Change",
    actionOdjava: "Deregistration",
  },
  approvals: {
    title: "Approval Requests",
    pendingTitle: "Pending Requests",
    noApprovals: "No pending requests",
    approve: "Approve",
    reject: "Reject",
    confirmReject: "Confirm rejection",
    rejectionReason: "Reason",
    rejectionReasonPlaceholder: "Enter the rejection reason...",
    approved: "Request approved",
    rejected: "Request rejected",
    alreadyDecided: "This request has already been decided.",
    newPending: "New approval request",
    actionCreate: "Registration",
    actionUpdate: "Change",
    actionDelete: "Deregistration",
    proposedData: "Proposed Data",
    currentData: "Current Data",
    field: "Field",
    before: "Before",
    after: "After",
    employee: "Employee",
    action: "Action",
    requestedAt: "Requested at",
    contract: {
      title: "Contract terms",
      jobTitle: "Job title",
      workingHours: "Working hours",
      vacationDays: "Vacation days",
      salary: "Gross salary",
      desiredNetSalary: "Desired net salary",
      workLocation: "Work location",
      period: "Period",
    },
    termination: {
      title: "Termination terms",
      type: "Type",
      date: "Termination date",
      noticeDays: "Notice period (days)",
      unusedVacation: "Unused vacation",
      reason: "Reason",
    },
  },
  dashboard: {
    notification: {
      title: "Notifications",
      message:
        "Welcome to the new version of Vomi app! Now you can more easily manage employees and payroll. New digital reports module is now available!",
    },
    employees: {
      label: "Employees",
      active: "Active",
    },
    payroll: {
      label: "Next Payroll",
      notScheduled: "Not scheduled",
    },
    recentActivity: {
      title: "Recent Activity",
      newEmployee: "New employee added",
      payrollCreated: "Payroll created",
      timesheetUpdated: "Timesheet updated",
      daysAgo: "days ago",
      noActivity: "No recent activity",
    },
  },
  payrollPage: {
    title: "Payroll",
    periodLabel: "Period",
    loading: "Loading...",
    error: "Failed to load payroll data.",
    retry: "Try again",
    status: {
      title: "Payroll status",
      month: "Payroll month",
      expectedPaymentDate: "Expected payment date",
      label: "Status",
      notScheduled: "Not scheduled yet",
      TODO: "Requested",
      IN_PROGRESS: "In progress",
      DONE: "Completed",
    },
    hours: {
      title: "Working hours",
      completeMessage: "All employees have their hours entered.",
      incompleteMessage: "The following employees still need their hours entered for this month:",
      goToEmployee: "Open employee",
    },
    decisions: {
      title: "Unconfirmed decisions",
      noneMessage: "There are no unconfirmed decisions for this month.",
      pendingMessage: "There are decisions for the selected month that have not been confirmed yet. Confirm or cancel them before scheduling payroll.",
      from: "from",
      types: {
        VACATION: "Annual leave",
        SICK_LEAVE: "Sick leave",
        LONG_TERM_ABSENCE: "Long-term absence",
        OTHER: "Other absence",
        REGISTRATION: "Employee registration",
        CONTRACT_CHANGE: "Contract change",
        TERMINATION: "Employee deregistration",
      },
    },
    schedule: {
      title: "Schedule payroll",
      dateLabel: "Expected payment date",
      submit: "Schedule payroll",
      resubmit: "Change date",
      blockedMessage: "Scheduling is only possible once every employee's hours are entered.",
      paymentDeadlineWarning:
        "Under the Croatian Labour Act, salary must be paid by the 15th day of the month for the previous month, unless the employment or collective agreement states otherwise.",
      lockedMessage: "Work hours and the payroll calculation date cannot be edited because the payroll calculation is in progress or completed. Please contact Vomi d.o.o. for changes.",
      toast: {
        scheduled: "Payroll scheduled successfully.",
      },
    },
  },
  hoursPage: {
    title: "Hours",
    periodLabel: "Period",
    sortLabel: "Surname",
    sortAsc: "A–Z",
    sortDesc: "Z–A",
    searchPlaceholder: "Search employees…",
    noSearchResults: "No results for your search.",
    error: "Failed to load work time data.",
    retry: "Try again",
    lockedMessage: "Work hours and the payroll calculation date cannot be edited because the payroll calculation is in progress or completed. Please contact Vomi d.o.o. for changes.",
    empty: "No data for the selected period.",
    columns: {
      name: "Full name",
      regular: "Regular",
      overtime: "Overtime",
      night: "Night",
      vacation: "Vacation (days)",
      sickLeave: "Sick leave (days)",
      workingDays: "Working days",
      nonWorkingDays: "Non-working days",
    },
    groups: {
      hours: "Hours",
      days: "Days",
    },
    labels: {
      regular: "Regular",
      overtime: "Overtime",
      night: "Night",
      vacation: "Vacation",
      sickLeave: "Sick leave",
      working: "Working",
      nonWorking: "Non-working",
    },
  },
  reports: {
    title: "Reports",
    subtitle: "Review and digitally sign your reports.",
    empty: "No reports available yet.",
    yearTabLabel: "Final reports for {year}",
    searchPlaceholder: "Search reports…",
    noSearchResults: "No reports match your search.",
    download: "Download",
    sign: "Sign document",
    statusSigned: "Signed",
    statusUnsigned: "Not signed",
    signSuccess: "Document signed",
    signError: "Error signing the document",
    downloadError: "Error downloading the report",
    loadError: "Error loading reports",
    signatureRequired: "Set up a digital signature in your profile to sign reports.",
    businessType: {
      llc: "LLC",
      craft: "Craft business",
      association: "Association",
    },
  },
};

export type LocaleType = typeof enLocale;
